import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import mockData from "../../services/mockAppAnalytics.json";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { KpiCard } from "../mobile/MobileAppsPanel";

export const websites = [
  {
    id: "web1",
    name: "Steel Fitness Website",
    domain: "steelfitness.com",
    data: mockData,
    liveDate: "2025-12-10",
  },
  {
    id: "web2",
    name: "Yoga Pro Portal",
    domain: "yogapro.com",
    data: mockData,
    liveDate: "2024-11-15",
  },
];

interface WebsitePanelProps {
  section: string;
}

export const WebsitePanel: React.FC<WebsitePanelProps> = ({ section }) => {
  const navigate = useNavigate();

  /* ================================
       ALL WEBSITES VIEW
    ================================= */

  if (section === "allWebsites") {
    return (
      <div>
        <h2>Your Websites</h2>

        <div style={{ marginTop: 20, display: "flex", gap: 20 }}>
          {websites.map((site) => (
            <div
              key={site.id}
              onClick={() => {}} // Can navigate to analytics later if needed
              style={{
                background: "#F4F6FA",
                padding: 20,
                borderRadius: 12,
                width: 300,
                cursor: "pointer",
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#10B981",
                  background: "#E6F9F0",
                  padding: "4px 8px",
                  borderRadius: "20px",
                }}
              >
                🚀{" "}
                {site.liveDate
                  ? `Live since ${new Date(site.liveDate).toLocaleDateString()}`
                  : "Coming Soon"}
              </div>
              <h3>{site.name}</h3>
              <p style={{ fontSize: 12 }}>{site.domain}</p>

              <button
                style={{
                  marginTop: 10,
                  padding: "6px 12px",
                  borderRadius: 6,
                  border: "none",
                  background: "#714B67",
                  color: "white",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  localStorage.setItem("default_website", site.id);
                }}
              >
                Make Default
              </button>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return null;
};
